import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Список ролей
    async getUserRoles(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      return await this.get(`roles?${params.toString()}${sorting}`);
    },
    // Получение роли по id
    async getUserRoleById(id) {
      return await this.get(`roles/id/${id}`);
    },
    // Создание роли
    async postUserRole(data) {
      return await this.post('roles', data);
    },
    // Изменение роли
    async putUserRole(data) {
      return await this.put(`roles/${data.id}`, data);
    },
    // Удаление роли
    async deleteUserRole(data) {
      return await this.delete(`roles/${data.id}`, null);
    },
    // Получение списка разрешений
    async getPermissions(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      return await this.get(`permissions?${params.toString()}${sorting}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/roles.js